export const formatNum = num => num.toLocaleString();
